module.exports = __webpack_public_path__ + "img/il_heroes_adp.f3cce453.svg";